"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const ChargeStatus_1 = require("../models/charges/ChargeStatus");
const ChargeTypes_1 = require("../models/charges/ChargeTypes");
const TransactionType_1 = require("../models/rates/TransactionType");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class PendingChargeValidator extends GenericValidator_1.default {
    transactionTypes = Object.values(TransactionType_1.TransactionType);
    chargeStatus = Object.values(ChargeStatus_1.ChargeStatus);
    chargeTypes = Object.values(ChargeTypes_1.ChargeTypes);
    _adjustmentRecordSchema = joi_1.default.object({
        timestamp: joi_1.default.number().required(),
        email: joi_1.default.string().required(),
        change: joi_1.default.string().required(),
        note: joi_1.default.string().required(),
    });
    _chargeDetailSchema = joi_1.default.object({
        inboundReferenceNumber: joi_1.default.string().allow('').optional(),
        outboundReferenceNumber: joi_1.default.string().allow('').optional(),
        trackingNumber: joi_1.default.string().allow('').optional(),
        sku: joi_1.default.string().allow('').optional(),
        weight: joi_1.default.number().optional(),
        bolNumber: joi_1.default.string().allow('').optional(),
        poNumber: joi_1.default.string().allow('').optional(),
        lotNumber: joi_1.default.string().allow('').optional(),
        serialNumber: joi_1.default.string().allow('').optional(),
        muLabel: joi_1.default.string().allow('').optional(),
        storageUoM: joi_1.default.string().allow('').optional(),
        inventoryUoM: joi_1.default.string().allow('').optional(),
        trailerNumber: joi_1.default.string().allow('').optional(),
        locationName: joi_1.default.string().allow('').optional(),
        itemClassification: joi_1.default.string().allow('').optional(),
    });
    _chargeSchema = joi_1.default.object({
        id: joi_1.default.string().allow('').required(),
        orgKey: joi_1.default.string().required(),
        customerId: joi_1.default.string().required(),
        customerName: joi_1.default.string().required(),
        warehouseId: joi_1.default.number().optional(),
        warehouseName: joi_1.default.string().allow('').optional(),
        class: joi_1.default.string().allow('').optional(),
        transactionId: joi_1.default.number().optional(),
        glAccount: joi_1.default.string().allow('').optional(),
        transactionType: joi_1.default.string()
            .valid(...this.transactionTypes)
            .required(),
        category: joi_1.default.string().required(),
        chargeType: joi_1.default.string()
            .valid(...this.chargeTypes)
            .required(),
        chargeLabel: joi_1.default.string().allow('').optional(),
        memo: joi_1.default.string().allow('').optional(),
        countingUnit: joi_1.default.string().allow('').optional(),
        qty: joi_1.default.number().precision(4).optional(),
        chargePerUnit: joi_1.default.number().precision(4).required(),
        total: joi_1.default.when('qty', {
            is: joi_1.default.number().exist(),
            then: joi_1.default.number().precision(4).required(),
            otherwise: joi_1.default.forbidden(),
        }),
        // MUST TEST:  set total key with value of undefined...
        status: joi_1.default.string()
            .valid(...this.chargeStatus)
            .required(),
        created: joi_1.default.number().required(),
        confirmDate: joi_1.default.number().optional(),
        chargeDetail: this._chargeDetailSchema.required(),
        chargeAdjustments: joi_1.default.array()
            .items(this._adjustmentRecordSchema)
            .required(),
        chargeEdits: joi_1.default.array().items(this._adjustmentRecordSchema).required(),
        predefinedChargeId: joi_1.default.string().allow('').optional(),
        predefinedManualRateId: joi_1.default.string().allow('').optional(),
    }).required();
    validate(input) {
        super.validate(input, 'IPendingCharge', this._chargeSchema);
    }
    validateAndHandleIssues(input, rootPath = '$') {
        const result = this._chargeSchema.validate(input, {
            abortEarly: false,
            convert: false,
        });
        return super.handleIssues(result, 'IPendingCharge', rootPath);
    }
}
exports.default = PendingChargeValidator;
